import { Grid } from "@mui/system";
import style from "../../../assets/css/dashboard.module.scss";

function DashboardFooter() {
  return (
    <>
      <section className={style.DashFooterSection}>
        <Grid container spacing={0} className="customeContainer">
          <Grid size={{ xs: 12 }}>
            <div className={style.DashFooter}>
              <span style={{ color: "#545454" }}>
                <a style={{ color: 'inherit', textTransform: 'capitalize' }} href="https://belgiumwebnet.com/" target="_blank" aria-label="bw" rel="noreferrer">   © All Rights Reserved. Designed & Developed by Belgium Webnet Inc. </a>
              </span>
            </div>
          </Grid>
        </Grid>
      </section>
    </>
  );
}

export default DashboardFooter;
